module.exports = __webpack_public_path__ + "img/logo_fr.6139dc25.png";